// HOSTNAME_ENV_MAP: Maps hostname matchers to envCode.
const HOSTNAME_ENV_MAP: Array<[(h: string) => boolean, string]> = [
  [(h) => h === 'localhost', 'local'],
  [(h) => h.includes('tst') || h.includes('test'), 'tst'],
  [(h) => h.includes('sbx'), 'sbx'],
  [(h) => h.includes('qap'), 'qap'],
  [(h) => h.includes('qua'), 'qua'],
  [(h) => h.includes('prd') || h.includes('prod'), 'prd'],
  [(h) => h === 'preview.developer.availity.com', 'prd'],
];

export function resolveBaseUrl(): string | null {
  const { hostname } = window.location;
  for (const [matcher, envCode] of HOSTNAME_ENV_MAP) {
    if (matcher(hostname)) {
      if (envCode === 'local') return null;
      return envCode === 'prd'
        ? 'https://preview.api.availity.com'
        : `https://${envCode}-preview.api.availity.com`;
    }
  }
  return null;
}

export const getCurrentEnv = (): string | null => {
  const { hostname } = window.location;
  for (const [matcher, envCode] of HOSTNAME_ENV_MAP) {
    if (matcher(hostname)) {
      return envCode;
    }
  }
  return null;
};

const base = resolveBaseUrl();

export const getUnifiedGatewayBaseUrl = () =>
  base ? `${base}/extend` : 'http://localhost:8001';

export const getMcpBaseUrl = () => (base ? `${base}/mcp` : 'http://localhost:8002/mcp');
